import {useCallback, useRef} from 'react';
import {type LottieRefCurrentProps} from 'lottie-react';

type UseReducedMotionLottieProps = {
  stopFrame?: number;
};

const REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';

const getPrefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia(REDUCED_MOTION_MEDIA_QUERY).matches;

function useReducedMotionLottie({
  stopFrame = 0,
}: UseReducedMotionLottieProps) {
  const lottieRef = useRef<LottieRefCurrentProps | null>(null);
  const prefersReducedMotion = getPrefersReducedMotion();

  const onDOMLoaded = useCallback(() => {
    if (!prefersReducedMotion) return;
    lottieRef.current?.goToAndStop(stopFrame, true);
  }, [prefersReducedMotion, stopFrame]);

  return {
    lottieRef,
    onDOMLoaded,
    autoplay: !prefersReducedMotion,
    loop: !prefersReducedMotion,
  };
}

export {useReducedMotionLottie};
